export default [
    {
        path: "/hyc",
        name: "hyc__root__",
        redirect: {
            name: "hyc-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            isPublic: true,
            parent: "hyc",
            title: "首页",
        },
        children: [
            {
                path: "index",
                name: "hyc-index",
                component: () => import("@/views/hyc/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/hyc/customers",
        name: "hyc-customers",
        meta: {
            title: "客户管理",
            icon: "mkt-enterprise",
            parent: "hyc",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/hyc/customers/organizations",
        children: [
            {
                path: "organizations/:id(\\d+)/grants",
                name: "hyc-customer-grants",
                hidden: true,
                component: () => import("@/views/hyc/GrantPage.vue"),
                meta: { title: "免计费授权", permissionsAny: ["manage_hyc_grant"], activeMenu: "/hyc/customers/organizations" },
            },
            {
                path: "organizations",
                name: "hyc-customers-organizations",
                component: () => import("@/views/hyc/organizations.vue"),
                meta: {
                    title: "组织管理",
                    icon: "mkt-organization",
                    affix: false,
                },
            },
            {
                path: "users",
                name: "hyc-customers-users",
                component: () => import("@/views/hyc/users.vue"),
                meta: {
                    title: "用户管理",
                    icon: "mkt-account-user",
                    affix: false,
                },
            },
            {
                path: "schemes",
                name: "hyc-customers-schemes",
                component: () => import("@/views/hyc/schemes.vue"),
                meta: {
                    title: "方案管理",
                    icon: "cms-oss",
                    affix: false,
                },
            },
            {
                path: "salary",
                name: "hyc-salary",
                component: () => import("@/views/hyc/salary.vue"),
                meta: {
                    title: "薪资结算",
                    icon: "bill",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/hyc/setting",
        name: "hyc-setting",
        meta: {
            title: "基础配置",
            icon: "all-setting",
            parent: "hyc",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/hyc/setting/crops",
        children: [
            {
                path: "crops",
                name: "hyc-setting-crops",
                component: () => import("@/views/hyc/setting/crops.vue"),
                meta: {
                    title: "作物配置",
                    icon: "plant",
                    affix: false,
                },
            },
            {
                path: "varieties",
                name: "hyc-setting-varieties",
                component: () => import("@/views/hyc/setting/varieties.vue"),
                meta: {
                    title: "品种配置",
                    icon: "prod-goods-fertilizer",
                    affix: false,
                },
            },
            {
                path: "levels",
                name: "hyc-setting-levels",
                component: () => import("@/views/hyc/setting/levels.vue"),
                meta: {
                    title: "等级配置",
                    icon: "dev-control",
                    affix: false,
                },
            },
            {
                path: "tare",
                name: "hyc-setting-tare",
                component: () => import("@/views/hyc/setting/tare.vue"),
                meta: {
                    title: "皮重配置",
                    icon: "dev-device-es",
                    affix: false,
                },
            },
            {
                path: "specs",
                name: "hyc-setting-specs",
                component: () => import("@/views/hyc/setting/specs.vue"),
                meta: {
                    title: "规格配置",
                    icon: "cms-resource",
                    affix: false,
                },
            },
            {
                path: "positions",
                name: "hyc-setting-positions",
                component: () => import("@/views/hyc/setting/positions.vue"),
                meta: {
                    title: "岗位配置",
                    icon: "cms-account-permission",
                    group: 512,
                    affix: false,
                },
            },
            {
                path: "configs",
                name: "hyc-platform-configs",
                component: () => import("@/views/hyc/platform.vue"),
                meta: {
                    title: "平台配置",
                    icon: "all-setting",
                    affix: false,
                    platformTab: "configs",
                },
            },
        ],
    },
    {
        path: "/hyc/permission",
        name: "hyc-permission-root",
        meta: {
            title: "权限配置",
            icon: "cms-account-permission",
            parent: "hyc",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        children: [
            {
                path: "",
                name: "hyc-permission-index",
                component: () => import("@/views/hyc/permission.vue"),
                meta: {
                    title: "权限配置",
                    icon: "cms-account-permission",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/hyc/refunds",
        name: "hyc-customer-refunds",
        component: () => import("@/layouts/default.vue"),
        redirect: "/hyc/billing/recharge-records",
        meta: {
            title: "充值与退款",
            icon: "finance-bill-pay",
            parent: "hyc",
            permissionsAny: ["manage_after_sale", "manage_bill"],
        },
        children: [
            {
                path: "/hyc/billing/recharge-records",
                name: "hyc-billing-recharge-records",
                component: () => import("@/views/hyc/billing.vue"),
                meta: { title: "充值记录", icon: "finance-bill", billingTab: "rechargeRecords" },
            },
            {
                path: "/hyc/billing/refunds",
                name: "hyc-customer-refund-list",
                component: () => import("@/views/hyc/refunds/index.vue"),
                meta: { title: "退款申请记录", icon: "finance-bill-pay" },
            },
            {
                path: "/hyc/billing/refunds/:id(\\d+)",
                name: "hyc-customer-refund-detail",
                hidden: true,
                component: () => import("@/views/hyc/refunds/detail.vue"),
                meta: { title: "退款申请详情", activeMenu: "/hyc/billing/refunds" },
            },
        ],
    },
    {
        path: "/hyc/billing",
        name: "hyc-billing",
        meta: {
            title: "计费管理",
            icon: "finance-bill",
            parent: "hyc",
            group: 512,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/hyc/billing/pricing-plans",
        children: [
            {
                path: "pricing-plans",
                name: "hyc-billing-pricing-plans",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "计费套餐",
                    icon: "finance-bill",
                    affix: false,
                    billingTab: "pricingPlans",
                },
            },
            {
                path: "operation-items",
                name: "hyc-billing-operation-items",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "计费项目",
                    icon: "bill",
                    affix: false,
                    billingTab: "operationItems",
                },
            },
            {
                path: "price-rules",
                name: "hyc-billing-price-rules",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "价格规则",
                    icon: "price",
                    affix: false,
                    billingTab: "priceRules",
                },
            },
            {
                path: "discount-tiers",
                name: "hyc-billing-discount-tiers",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "阶梯折扣",
                    icon: "discount",
                    affix: false,
                    billingTab: "discountTiers",
                },
            },
            {
                path: "accounts",
                name: "hyc-billing-accounts",
                component: () => import("@/views/hyc/billing.vue"),
                meta: {
                    title: "计费账户",
                    icon: "finance-bill",
                    affix: false,
                    billingTab: "accounts",
                },
            },
            // {
            //     path: "usage-records",
            //     name: "hyc-billing-usage-records",
            //     component: () => import("@/views/hyc/billing.vue"),
            //     meta: {
            //         title: "使用记录",
            //         icon: "data",
            //         affix: false,
            //         billingTab: "usageRecords",
            //     },
            // },
            // {
            //     path: "sync-records",
            //     name: "hyc-billing-sync-records",
            //     component: () => import("@/views/hyc/billing.vue"),
            //     meta: {
            //         title: "同步记录",
            //         icon: "transfer",
            //         affix: false,
            //         billingTab: "syncRecords",
            //     },
            // },
        ],
    },
    // {
    //     path: "/hyc/billing",
    //     name: "hyc-billing",
    //     meta: {
    //         title: "计费管理",
    //         icon: "finance-bill",
    //         parent: "hyc",
    //         group: 512,
    //     },
    //     component: () => import("@/layouts/default.vue"),
    //     redirect: "/hyc/billing/operation-items",
    //     children: [
    //         {
    //             path: "operation-items",
    //             name: "hyc-billing-operation-items",
    //             component: () => import("@/views/hyc/billing.vue"),
    //             meta: {
    //                 title: "计费操作项",
    //                 icon: "bill",
    //                 affix: false,
    //                 billingTab: "operationItems",
    //             },
    //         },
    //         {
    //             path: "price-rules",
    //             name: "hyc-billing-price-rules",
    //             component: () => import("@/views/hyc/billing.vue"),
    //             meta: {
    //                 title: "价格规则",
    //                 icon: "price",
    //                 affix: false,
    //                 billingTab: "priceRules",
    //             },
    //         },
    //         {
    //             path: "discount-tiers",
    //             name: "hyc-billing-discount-tiers",
    //             component: () => import("@/views/hyc/billing.vue"),
    //             meta: {
    //                 title: "阶梯折扣",
    //                 icon: "discount",
    //                 affix: false,
    //                 billingTab: "discountTiers",
    //             },
    //         },
    //         {
    //             path: "accounts",
    //             name: "hyc-billing-accounts",
    //             component: () => import("@/views/hyc/billing.vue"),
    //             meta: {
    //                 title: "计费账户",
    //                 icon: "finance-bill",
    //                 affix: false,
    //                 billingTab: "accounts",
    //             },
    //         },
    //         {
    //             path: "usage-records",
    //             name: "hyc-billing-usage-records",
    //             component: () => import("@/views/hyc/billing.vue"),
    //             meta: {
    //                 title: "使用记录",
    //                 icon: "data",
    //                 affix: false,
    //                 billingTab: "usageRecords",
    //             },
    //         },
    //         {
    //             path: "sync-records",
    //             name: "hyc-billing-sync-records",
    //             component: () => import("@/views/hyc/billing.vue"),
    //             meta: {
    //                 title: "同步记录",
    //                 icon: "transfer",
    //                 affix: false,
    //                 billingTab: "syncRecords",
    //             },
    //         },

    //     ],
    // },

    // {
    //     path: "/hyc/dashboard",
    //     name: "hyc-dashboard",
    //     meta: {
    //         title: "数据查看",
    //         icon: "dashboard",
    //         parent: "hyc",
    //         group: 512,
    //     },
    //     component: () => import("@/layouts/default.vue"),
    //     redirect: "/hyc/dashboard/overview",
    //     children: [
    //         {
    //             path: "overview",
    //             name: "hyc-dashboard-overview",
    //             component: () => import("@/views/hyc/dashboard.vue"),
    //             meta: {
    //                 title: "总览",
    //                 icon: "dashboard",
    //                 affix: false,
    //                 dashboardType: "overview",
    //             },
    //         },
    //         {
    //             path: "weighing",
    //             name: "hyc-dashboard-weighing",
    //             component: () => import("@/views/hyc/dashboard.vue"),
    //             meta: {
    //                 title: "称重",
    //                 icon: "dashboard",
    //                 affix: false,
    //                 dashboardType: "weighing",
    //             },
    //         },
    //         {
    //             path: "inventory",
    //             name: "hyc-dashboard-inventory",
    //             component: () => import("@/views/hyc/dashboard.vue"),
    //             meta: {
    //                 title: "库存",
    //                 icon: "dashboard",
    //                 affix: false,
    //                 dashboardType: "inventory",
    //             },
    //         },
    //         {
    //             path: "salary",
    //             name: "hyc-dashboard-salary",
    //             component: () => import("@/views/hyc/dashboard.vue"),
    //             meta: {
    //                 title: "薪资",
    //                 icon: "dashboard",
    //                 affix: false,
    //                 dashboardType: "salary",
    //             },
    //         },
    //     ],
    // },
    {
        path: "/hyc/dashboard",
        name: "hyc-dashboard",
        component: () => import("@/layouts/default.vue"),
        meta: { title: "数据看板", icon: "dashboard", parent: "hyc", group: 512 },
        children: [
            {
                path: "",
                name: "hyc-dashboard-overview",
                component: () => import("@/views/hyc/dashboard.vue"),
                meta: { title: "数据看板", icon: "dashboard", affix: false },
            },
        ],
    },
];
